import { ViolationsCustomViewFields, ViolationsCustomViewKey } from '../constants/violationsCustomView.constants';
import { ISelectOption } from './selectOption.interface';

export const ViolationsCustomViewOptions: ISelectOption[] = [
  {
    id: ViolationsCustomViewKey.overSharedResources,
    value: ViolationsCustomViewKey.overSharedResources,
    displayName: ViolationsCustomViewFields[ViolationsCustomViewKey.overSharedResources],
  },
  {
    id: ViolationsCustomViewKey.untrustedGuestAccess,
    value: ViolationsCustomViewKey.untrustedGuestAccess,
    displayName: ViolationsCustomViewFields[ViolationsCustomViewKey.untrustedGuestAccess],
  },
  {
    id: ViolationsCustomViewKey.untrustedMemberAccess,
    value: ViolationsCustomViewKey.untrustedMemberAccess,
    displayName: ViolationsCustomViewFields[ViolationsCustomViewKey.untrustedMemberAccess],
  },
  {
    id: ViolationsCustomViewKey.nonCompliantConnections,
    value: ViolationsCustomViewKey.nonCompliantConnections,
    displayName: ViolationsCustomViewFields[ViolationsCustomViewKey.nonCompliantConnections],
  },
  {
    id: ViolationsCustomViewKey.insecureCommunication,
    value: ViolationsCustomViewKey.insecureCommunication,
    displayName: ViolationsCustomViewFields[ViolationsCustomViewKey.insecureCommunication],
  },
  {
    id: ViolationsCustomViewKey.authenticationIssues,
    value: ViolationsCustomViewKey.authenticationIssues,
    displayName: ViolationsCustomViewFields[ViolationsCustomViewKey.authenticationIssues],
  },
  {
    id: ViolationsCustomViewKey.customCode,
    value: ViolationsCustomViewKey.customCode,
    displayName: ViolationsCustomViewFields[ViolationsCustomViewKey.customCode],
  },
  {
    id: ViolationsCustomViewKey.potentiallyRiskyDataFlow,
    value: ViolationsCustomViewKey.potentiallyRiskyDataFlow,
    displayName: ViolationsCustomViewFields[ViolationsCustomViewKey.potentiallyRiskyDataFlow],
  },
  {
    id: ViolationsCustomViewKey.suspiciousConfiguration,
    value: ViolationsCustomViewKey.suspiciousConfiguration,
    displayName: ViolationsCustomViewFields[ViolationsCustomViewKey.suspiciousConfiguration],
  },
];
